









import Vue from 'vue';
import {Component} from 'vue-property-decorator';

@Component
export default class Sider extends Vue {
  visible = true;
}
